import axios from "axios";
import Config from "@/config"

export default class LabelService {
    getLabels(lang) {
        const options = {
            headers: { ...Config.headers(null) },
            params: {
                locale: lang,
                fields: "key,value",
                "pagination[pageSize]": 100000
            },
        };
        return axios
            .get(
                Config.proxy + Config.url("labels"),
                options
            )
            .then(res => {
                return res.data.data
            });
    }
    getLanguages() {
        const options = {
            headers: { ...Config.headers(null) },
            params: {
                fields: "code,name"
            },
        };
        return axios
            .get(
                Config.proxy + Config.url("languages"),
                options
            )
            .then(res => res.data);
    }
}
